import type mapboxgl from 'mapbox-gl';
import { type ColourScheme, colourSchemes, getFromTheme } from '../../../theme';
import MapHelpers from '../../map.utils';
import type MapLayer from '../map-layer.enum';
import MapLayerManager from '../map-layer-manager.utils';
import MapLayerVisibility from '../map-layer-visibility.enum';

function addLineLayer(
  layer: MapLayer | string,
  paint: mapboxgl.LinePaint = {},
  groupLayerid?: string,
  drawingColour?: string
) {
  const colourScheme: ColourScheme | undefined = colourSchemes.get(
    getFromTheme('colourScheme')
  );
  new Promise((resolve) => {
    if (groupLayerid) {
      MapLayerManager.AddLayerinGroups(
        {
          id: layer,
          type: 'line',
          source: layer,
          layout: {
            visibility: MapLayerVisibility.NOT_VISIBLE,
          },
          paint: {
            ...paint,
            'line-color': drawingColour || colourScheme?.areaTint,
          },
        },
        [groupLayerid]
      );
    } else {
      MapHelpers.addLayer({
        id: layer,
        type: 'line',
        source: layer,
        layout: {
          visibility: MapLayerVisibility.NOT_VISIBLE,
        },
        paint: {
          ...paint,
          'line-color': drawingColour || colourScheme?.areaTint,
        },
      });
    }
    resolve(MapHelpers);
  });
}

export default addLineLayer;
